export default __webpack_public_path__ + "static/media/Tasset of Rapturous Battle.6e2de4f0.jpg";